// extracted by mini-css-extract-plugin
export var cardContainer = "_pi-0";
export var cardHeader = "_pi-2";
export var collapsedState = "_pi-3";
export var dragHandle = "_pi-5";
export var dragHandleIcon = "_pi-6";
export var dragging = "_pi-1";
export var titleArea = "_pi-4";